import { render, staticRenderFns } from "./confirm-delete-question.vue?vue&type=template&id=0af554ce&scoped=true"
import script from "./confirm-delete-question.vue?vue&type=script&lang=js"
export * from "./confirm-delete-question.vue?vue&type=script&lang=js"
import style0 from "./confirm-delete-question.vue?vue&type=style&index=0&id=0af554ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af554ce",
  null
  
)

export default component.exports